import React from "react";
import "./Career.scss";
import useInView from "../hooks/useInView";

// 최신순. 학력과 활동을 하나의 연대기로 합친다.
const CAREER = [
  {
    period: "2026.01 - 현재",
    title: "삼성청년SW·AI아카데미 (SSAFY)",
    lines: [
      "Java Track (Vue.js + Spring)",
      "2026 K-디지털 트레이닝 해커톤 기술혁신상 (고용노동부, 2026.08)",
      "공통 프로젝트 우수상 (2026.08)",
      "2026 SSAFY AI 챌린지 최우수상 (2026.04)",
    ],
  },
  {
    period: "2020.03 - 2026.02",
    title: "서일대학교",
    lines: ["소프트웨어학과 졸업 (학점 4.49 / 4.5)", "수석 졸업"],
  },
  {
    period: "2020.04 - 2025.02",
    title: "W.I.S 전공 동아리",
    lines: ["2021년도부터 회장 활동", "토이 프로젝트 참여 및 주도"],
  },
  {
    period: "2017.05 - 2018.12",
    title: "SMIX 프로그래밍 봉사 동아리",
    lines: ["기초 언어(C) 강의 담당"],
  },
  {
    period: "2017.03 - 2018.12",
    title: "IWOP 웹 개발 동아리",
    lines: ["백엔드 개발 담당"],
  },
  {
    period: "2016.03 - 2019.02",
    title: "선린인터넷고등학교",
    lines: ["졸업 (수석 졸업)"],
  },
];

function Career() {
  const [ref, inView] = useInView();

  return (
    <section className="section career" id="career" ref={ref}>
      <div className="container">
        <h2 className={`section-title reveal ${inView ? "is-in" : ""}`}>
          Career
        </h2>

        <ol className="career-list">
          {CAREER.map((item, index) => (
            <li
              className={`career-item reveal ${inView ? "is-in" : ""}`}
              style={{ "--delay": `${index * 70}ms` }}
              key={item.title}
            >
              <span className="career-period">{item.period}</span>

              <div className="career-body">
                <h3>{item.title}</h3>
                {item.lines.map((line) => (
                  <p key={line}>{line}</p>
                ))}
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default Career;
